import {
  DocumentReference,
  ISoftDelete,
  Timestamp,
} from '@principle-theorem/shared';
import { IAutomation } from '../automation/automation';
import { IAutomatedNotification } from '../notification/automated-notification';
import { IGeneratedTask } from '../task/generated-task';
import { IMarketingCampaign } from './campaign';
import { IMarketingCampaignRun } from './campaign-run';
import {
  IMarketingCampaignStep,
  MarketingCampaignStepConversionType,
} from './campaign-step';

export enum MarketingCampaignStepConversionStatus {
  Pending = 'pending',
  Queued = 'queued',
  Disabled = 'disabled',
  Skipped = 'skipped',
  Completed = 'completed',
  Converted = 'converted',
  Failed = 'failed',
  Cancelled = 'cancelled',
  Unsubscribed = 'unsubscribed',
  Unenrolled = 'unenrolled',
  ExceededCommunicationLimit = 'exceededCommunicationLimit',
}

export interface IBaseMarketingCampaignStepConversion extends ISoftDelete {
  campaignRef: DocumentReference<IMarketingCampaign>;
  campaignRunRef: DocumentReference<IMarketingCampaignRun>;
  automationRef?: DocumentReference<
    IAutomation<IAutomatedNotification | IGeneratedTask>
  >;
  stepRef: DocumentReference<IMarketingCampaignStep>;
  estimatedCost: number;
  estimatedCostRemaining: number;
  estimatedSegments?: number;
  incurredCost: number;
  estimatedRunDate?: Timestamp;
}

export type MarketingCampaignStepConversionStatusOptions =
  | {
      status: MarketingCampaignStepConversionStatus.Failed;
      failedAt: Timestamp;
      failedReason?: string;
    }
  | {
      status: MarketingCampaignStepConversionStatus.Completed;
      completedAt: Timestamp;
    }
  | {
      status: MarketingCampaignStepConversionStatus.Converted;
      convertedAt: Timestamp;
      conversionType: MarketingCampaignStepConversionType;
    }
  | {
      status: MarketingCampaignStepConversionStatus.Unsubscribed;
      unsubscribedAt: Timestamp;
    }
  | {
      status: MarketingCampaignStepConversionStatus.Skipped;
      skippedReason?: string;
    }
  | {
      status: MarketingCampaignStepConversionStatus.Cancelled;
      cancelledReason?: string;
    }
  | {
      status: Exclude<
        MarketingCampaignStepConversionStatus,
        | MarketingCampaignStepConversionStatus.Completed
        | MarketingCampaignStepConversionStatus.Converted
        | MarketingCampaignStepConversionStatus.Unsubscribed
        | MarketingCampaignStepConversionStatus.Failed
        | MarketingCampaignStepConversionStatus.Skipped
        | MarketingCampaignStepConversionStatus.Cancelled
      >;
    };

export type IMarketingCampaignStepConversion =
  IBaseMarketingCampaignStepConversion &
    MarketingCampaignStepConversionStatusOptions;

export const CAMPAIGN_STEP_CONVERSION_QUERY_PARAM_KEY = 'cid';
